// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__3s8zu","searchText":"Header_searchText__UyYKO"};